import React, { useState, ChangeEvent } from "react";
import { Button, Modal, Input, Radio, Divider, Steps } from "antd";
import { IoDocumentAttachOutline, IoMailOutline } from "react-icons/io5";
import {
  useForm,
  useFormContext,
  SubmitHandler,
  Controller,
  Form,
  FormProvider,
} from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import "./create-modal.scss";

interface Field {
  name: string;
  type: string;
  label: string;
  placeholder: string;
  rules: object;
}
interface CustomModalProps {
  title: string;
  isModalVisible: boolean;
  onOk: (data: Record<string, any>) => void;
  onCancel: () => void;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  fields: Field[];
  isStepOneCompleted: boolean;
}

const CreateModal = ({
  fields,
  isStepOneCompleted,
  title,
  isModalVisible,
  onOk,
  onCancel,
}: CustomModalProps) => {
  const methods = useForm({
    mode: "onChange",
    criteriaMode: "all",
    defaultValues: fields.reduce((acc, field) => {
      acc[field.name] = ""; // Tạo giá trị mặc định cho mỗi field
      return acc;
    }, {} as Record<string, any>),
  });
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = methods;

  return (
    <FormProvider {...methods}>
      <Modal
        okButtonProps={{ size: "large" }}
        cancelButtonProps={{ size: "large" }}
        width={800}
        style={{ top: 20, height: 550 }}
        open={isModalVisible}
        title={title}
        okText="Tiếp tục"
        cancelText="Hủy"
        onCancel={onCancel}
        onOk={handleSubmit(onOk)}
      >
        <Divider />
        <div className="modal-bank-menu">
          <div className="modal-bank-step" style={{ color: "#1677ff" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <IoDocumentAttachOutline />
            </div>
            <div className="step-title">Thông tin tài khoản</div>
          </div>
          <div style={{ width: "30%" }}>
            <Divider
              style={{
                borderColor: "#1677FF",
              }}
            />
          </div>

          <div className="modal-bank-step">
            <div style={{ display: "flex", alignItems: "center" }}>
              <IoMailOutline />
            </div>
            <div className="step-title">Gửi mã OTP</div>
          </div>
        </div>
        <Form>
          {fields.map((item) => (
            <div key={`#${item.name}`} className="modal-content">
              <div className="modal-label">{item.label}</div>
              <div style={{ position: "relative" }} className="modal-item">
                <Controller
                  name={item.name}
                  control={control}
                  rules={item.rules}
                  render={({ field }) => (
                    <Input
                      size="large"
                      type={item.type}
                      placeholder={item.placeholder}
                      {...field}
                    />
                  )}
                />
                <ErrorMessage
                  errors={errors}
                  name={item.name}
                  render={({ message }) => (
                    <p
                      style={{
                        color: "red",
                        marginBottom: 20,
                        position: "absolute",
                        top: "100%" /* Hiển thị thông báo lỗi ngay dưới trường input */,
                        left: 0,
                      }}
                    >
                      {message}
                    </p>
                  )}
                />
              </div>
            </div>
          ))}
        </Form>
      </Modal>
    </FormProvider>
  );
};

export default CreateModal;
